import type {ReactElement} from 'react';
import type {QRCodeFileExtension} from '@Libraries/qr-code/qr-code.types';

export interface QRCodeActionsProps {
  isCodeBlocked: boolean;
  customizeControl?: ReactElement | null;
  /** What is wrong with the payload, when the form itself can say. Null falls back to a hint naming the action the visitor reached for. */
  payloadIssueText: string | null;
  onDownload: (extension: QRCodeFileExtension) => Promise<void>;
  onCopy: () => Promise<void>;
}

export const QR_BLOCKED_HINT_DOWNLOAD_KEY = 'pmwjs_qr_generator_blocked_hint_download';
export const QR_BLOCKED_HINT_COPY_KEY = 'pmwjs_qr_generator_blocked_hint_copy';

export interface QRDownloadFormatRow {
  extension: QRCodeFileExtension;
  labelKey: string;
  descriptionKey: string;
  icon: string;
}

export const QR_DOWNLOAD_FORMAT_ROWS: QRDownloadFormatRow[] = [
  {extension: 'png', labelKey: 'pmwjs_png_image', descriptionKey: 'pmwjs_qr_generator_download_png_description', icon: 'icon-image'},
  {extension: 'svg', labelKey: 'pmwjs_qr_generator_download_svg', descriptionKey: 'pmwjs_qr_generator_download_svg_description', icon: 'icon-image'},
];
